// Blockly.tsx

import React, {
    forwardRef,
    useImperativeHandle,
    useRef,
} from 'react';
import BlocklyContent, { BlocklyContentRef } from './BlocklyContent';
import { ExecutionProvider } from '../contexts/ExecutionContext';

export interface BlocklyRef {
    getWorkspaceXml: () => string | undefined;
    getPhaserConfig: () => any | undefined;
}

interface BlocklyProps {
    onWin: () => void;
    onSave?: (workspace: string) => void;
    /**
     * When true, admin-specific features such as configuration import buttons
     * are displayed. Otherwise the component is rendered in student mode.
     */
    adminMode?: boolean;
    /** Initial statement value for JsonEditor */
    initialStatement?: string;
    /** Callback when statement changes */
    onStatementChange?: (statement: string) => void;
}

const BlocklyPhaser = forwardRef<BlocklyRef, BlocklyProps>(({ onWin, onSave, adminMode = false, initialStatement, onStatementChange }, ref) => {
    // On crée une ref vers le composant `BlocklyContent`
    const blocklyContentRef = useRef<BlocklyContentRef>(null);

    // useImperativeHandle nous permet d'exposer des méthodes publiques
    useImperativeHandle(ref, () => ({
        getWorkspaceXml: () => blocklyContentRef.current?.getWorkspaceXml(),
        getPhaserConfig: () => blocklyContentRef.current?.getPhaserConfig(),
    }));

    return (
        <ExecutionProvider>
            {/* On passe la ref au composant enfant */}
            <BlocklyContent
                ref={blocklyContentRef}
                onWin={onWin}
                onSave={onSave}
                adminMode={adminMode}
                initialStatement={initialStatement}
                onStatementChange={onStatementChange}
            />
        </ExecutionProvider>
    );
});

export default BlocklyPhaser;
